export const initialState = {
    menuIsOpen: false,
    isLogged: false,
    token: ''
  };

export default initialState;